import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { DeviceInventoryConfirmationSearchSchema } from './device-inventory-confirmation/-zod-schema';

/**
 * デバイス棚卸しの束ね（タグ）確認画面。
 *
 * 一覧（`/it-operation-core/packages/$packageId`）のグループ見出しの「確認画面へ」から遷移する。
 * 束ねの母集団は `tagId` だけで決まる（`packageId` / `patternId` はパンくず用）。
 */
export const Route = createFileRoute('/_staff/it-operation-core/device-inventory-confirmation')({
  validateSearch: zodValidator(DeviceInventoryConfirmationSearchSchema)
});